import { request } from "graphql-request";
import { graphql } from "gql/gql";

import { BACKEND_DOMAIN } from "utils/constants";
import {
    buildRequestHeaders,
} from "utils/helpers";

const queryFn = (accessToken: string, buildingModelCarbonReductionPlanId: string) =>
    request({
        url: `${BACKEND_DOMAIN}/graphql`,
        document: query,
        variables: { buildingModelCarbonReductionPlanId },
        requestHeaders: buildRequestHeaders(accessToken),
    }).then((data) => {
        if (data.buildingModelCarbonReductionPlanReports.error)
            throw new Error(data.buildingModelCarbonReductionPlanReports.error);
        return data.buildingModelCarbonReductionPlanReports
            ?.currentAnnualEndUseChart as CurrentAnnualEndUseChart;
    });

const query = graphql(`
    query buildingBaselineCurrentAnnualEndUseChart($buildingModelCarbonReductionPlanId: Uuid!) {
        buildingModelCarbonReductionPlanReports(buildingModelCarbonReductionPlanId: $buildingModelCarbonReductionPlanId) {
            error
            currentAnnualEndUseChart {
                carbonEmissions {
                    endUse
                    fuelType
                    value
                }
                energyConsumption {
                    endUse
                    fuelType
                    value
                }
                utilityCost {
                    endUse
                    fuelType
                    value
                }
            }
        }
    }
`);

export default queryFn;
